import createPlugin from "./createPlugin";

import PanelGridRenderer from "./Renderer/PanelGridRenderer";
import PanelGridForm from "./Form/PanelGridForm";

const panelGridPlugin = (settings) =>
    createPlugin({
        Renderer: PanelGridRenderer,
        Controls: PanelGridForm,
        ...settings,
    });

const panelGrid = panelGridPlugin();
export default panelGrid;
export { panelGridPlugin, PanelGridRenderer };
